export default {
  apiUrl: window.location.origin,
  assetUrl: process.env.CF_PAGES_URL,
  basename: process.env.REACT_APP_ROUTE_BASENAME || '/clients',
  clioBaseUrl: process.env.REACT_APP_CLIO_MANAGE_BASE_URL,
  clioClientId: process.env.REACT_APP_CLIO_MANAGE_CLIENT_ID,
  clioIdentityBaseUrl: process.env.REACT_APP_CLIO_IDENTITY_BASE_URL,
  clioQuestionnaireBaseUrl:
    process.env.REACT_APP_CLIO_QUESTIONNAIRE_BASE_URL || '/questionnaires',
  isDevelopmentMode: process.env.NODE_ENV === 'development',
  bugsnagApiKey: process.env.REACT_APP_BUGSNAG_API_KEY || '',
  reactAppRegion: process.env.REACT_APP_REGION || '',
  reactAppEnvironment: process.env.REACT_APP_ENVIRONMENT || '',
  termsOfServiceUrl:
    process.env.REACT_APP_TERMS_OF_SERVICE_URL ||
    'https://www.clio.com/tos-lawyaw/',
  webviewerHost: process.env.REACT_APP_WEBVIEWER_HOST || '/static/js/webviewer',
  webviewerLicenseKey: process.env.REACT_APP_WEBVIEWER_LICENSE_KEY || '',
  githubSha: process.env.REACT_APP_GITHUB_SHA || '',
};
